import React from 'react';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import './EndsInBadge.css';

export const EndsInBadge = ({ jackpotExpires: { hours, minutes } }) => {
    const { t } = useTranslations();

    return (
        <div className={'casino-thumbnail__badge casino-thumbnail__badge--endsIn'}>
            {t('endsIn')}
            <div className="casino-thumbnail__badge-icon"/>
            {hours > 0 && <div className="casino-thumbnail__badge_hours">{hours}{t('stripHr')}</div>}
            <div className="casino-thumbnail__badge_mins">{minutes}{t('stripMin')}</div>
        </div>
    );
};
